// extracted by mini-css-extract-plugin
module.exports = {"motionContainer":"TransitionProposalFlowSteps-module__motionContainer--3ryR5"};